import {
  EDIT_SURVEY,
  LIST_SURVEY,

  SURVEY_SUCCESS,
  SURVEY_ERROR,
  MAIL_INVITE,
  SAVE_QUESTION_ANSWER,
  GET_QUESTION,
  QUESTION_SUCCESS,
  QUESTION_ERROR,

  LIST_HORIZONTAL,
  HORIZONTAL_SUCCESS,
  HORIZONTAL_ERROR,

  LIST_VERTICAL,
  VERTICAL_SUCCESS,
  VERTICAL_ERROR

} from "./actionTypes"
const initialState = {
  successMsg: null,
  error: null,
  surveyData: [],
  horizontalData: []
}

const Survey = (state = initialState, action) => {
  switch (action.type) {

    case SURVEY_SUCCESS:
      state = {
        ...state,
        loading: false,
        successMsg: action.payload,
        surveyData: action.payload.data
      }
      break
    case SURVEY_ERROR:
      state = { ...state, error: action.payload, loading: false, }
      break

    // edit Servey
    case EDIT_SURVEY:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    // Get Question
    case GET_QUESTION:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break
    case QUESTION_SUCCESS:
      state = {
        ...state,
        loading: false,
        successMsg: action.payload
      }
      break

    case QUESTION_ERROR:
      state = {
        ...state,
        loading: false,
        error: action.payload
      }
      break

    // Save question answer
    case SAVE_QUESTION_ANSWER:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    // mail invite
    case MAIL_INVITE:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    // list Servey
    case LIST_SURVEY:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break


    // horizontal
    case LIST_HORIZONTAL:
      state = {
        ...state,
        horizontalLoading: true,
        successMsg: null,
        error: null
      }
      break
    case HORIZONTAL_SUCCESS:
      state = {
        ...state,
        horizontalLoading: false,
        successMsg: action.payload,
        horizontalData: action.payload.data
      }
      break
    case HORIZONTAL_ERROR:
      state = {
        ...state,
        error: action.payload,
        horizontalLoading: false,
      }
      break

    //vertical
    case LIST_VERTICAL:
      state = {
        ...state,
        verticalLoading: true,
        successMsg: null,
        error: null
      }
      break
    case VERTICAL_SUCCESS:
      state = {
        ...state,
        verticalLoading: false,
        successMsg: action.payload,
        verticalData: action.payload.data
      }
      break
    case VERTICAL_ERROR:
      state = {
        ...state,
        error: action.payload,
        verticalLoading: false,
      }
      break

    default:
      state = { ...state }
      break
  }
  return state
}

export default Survey
